import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import serverHost from "../../services/serverHost";
import Estoque from "./components/Estoque";
import EscolasExclusividade from "./components/EscolasExclusividade";

export default function ProdutoCategoria(props) {
  const [produtoId] = useState(Number(props.match.params.id));
  const history = props.history;
  const [carregando, setCarregando] = useState(false);
  const [produto, setProduto] = useState({});
  const [comboCategoria, setComboCategoria] = useState([]);
  const [imagens, setImagens] = useState([]);
  const [imagemPrincipal, setImagemPrincipal] = useState("");
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (produtoId > 0) {
      carregarProduto();
    }
    carregarComboCategoria();
  }, []);

  const carregarComboCategoria = () => {
    api
      .get("produtos/listarCategorias")
      .then((produtoCategorias) => {
        setComboCategoria(produtoCategorias);
      })
      .catch((err) => {
        console.log(err);
        notification("warning", "Erro ao listar as categorias de produtos.");
      });
  };

  const carregarProduto = () => {
    setCarregando(true);

    api
      .get("produtos/carregar", { id: produtoId })
      .then((produto) => {
        if (produto.valorVenda)
          produto.valorVenda = (produto.valorVenda / 100).toFixed(2);
        setProduto(produto);
        setCarregando(false);
        listarImagens(produto.imagemPrincipal);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar produto");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    setProduto(params);
    if (produtoId > 0) {
      params.id = produtoId;
      api
        .post("produtos/editar", params)
        .then((res) => {
          notification("success", "Produto editado!");
          setProduto({});
          history.goBack();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("produtos/inserir", params)
        .then((res) => {
          notification("success", "Produto salvo!");
          setProduto({});
          history.push(`/app/produto`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Categoria inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fProduto = {
    title: produto.id ? "Editar produto" : "Novo produto",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: produto.nome,
        required: true,
        space: 6,
      },
      categoriaId: {
        label: "Categoria",
        type: "select",
        emptyItem: true,
        array: {
          data: comboCategoria,
          value: "id",
          desc: "nome",
        },
        value: produto.categoriaId,
        space: 6,
      },
      produtoPerto: {
        label: "Produto Perto",
        type: "select",
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: produto.produtoPerto,
      },
      valorVenda: {
        label:
          "Valor específico de venda (0 ou nulo p/ utilizar grupos de preço)",
        type: "number",
        value: produto.valorVenda,
        required: false,
        space: 6,
      },
      descricao: {
        label: "Descrição",
        type: "textarea",
        value: produto.descricao,
        required: false,
        space: 12,
      },
      altura: {
        label: "Altura (cm)",
        type: "number",
        value: produto.altura,
        required: false,
        space: 3,
      },
      largura: {
        label: "Largura (cm)",
        type: "number",
        value: produto.largura,
        required: false,
        space: 3,
      },
      comprimento: {
        label: "Comprimento (cm)",
        type: "number",
        value: produto.comprimento,
        required: false,
        space: 3,
      },
      peso: {
        label: "Peso (g)",
        type: "number",
        value: produto.peso,
        required: false,
        space: 3,
      },
      inativacao: {
        label: "Inativação",
        type: "date",
        value: produto.inativacao
          ? produto.inativacao.split(" ")[0]
          : undefined,
      },
    },

    submit: {
      label: "salvar",
      action: salvar,
    },

    history,
    close: true,

    customActions: produto.id
      ? [
          {
            label: "Duplicar produto",
            action: () =>
              history.push(`/app/produto/produto-duplicacao/${produto.id}`),
          },
        ]
      : undefined,
  };

  const listarImagens = () => {
    api
      .get("produtos/listarImagens", { id: produtoId })
      .then((imagens) => {
        setImagens(imagens);
        setImagemPrincipal(imagemPrincipal);
      })
      .catch((e) => notification("error", "Erro ao listar imagens"));
  };

  const adicionarImagem = (formulario) => {
    const imagemAdicionar = new FormData();

    imagemAdicionar.append("produtoId", produtoId);

    if (formulario.fileUpload && formulario.fileUpload.length > 0) {
      imagemAdicionar.append("arquivo", formulario.fileUpload[0]);
    } else {
      return notification("warning", "Selecione um arquivo");
    }

    api
      .put("produtos/inserirImagem", imagemAdicionar)
      .then((codes) => {
        notification("success", "Imagem adicionada!");
        return listarImagens();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Arquivo inválido");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const formUpload = {
    title: "Nova imagem",
    form: {
      fileUpload: {
        label: "Nova Imagem",
        type: "file",
        accept: "image/png, image/gif, image/jpeg",
      },
    },
    submit: {
      label: "Adicionar",
      action: adicionarImagem,
    },
  };

  const selecionarImagemPrincipal = (imagem) => {
    if(produto.imagemPrincipal === imagem.imagemNome){
      notification("success", "Imagem já selecionada como principal.");
      return;
    }

    api
      .post("produtos/selecionarImagemPrincipal", {produtoId, imagemPrincipal: imagem.imagemNome})
      .then(() => {
        notification("success", "Imagem marcada como imagem principal.");
        return listarImagens();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          default:
            return notification("error", "Não foi possível marcar a imagem como principal.");
        }
      });
  };

  const visualizarImagem = (imagem) => {
    window.open(`${serverHost()}/${imagem.imagemUrl}`, "_blank");
  };

  const removerImagem = (imagem) => {
    api
      .delete("produtos/removerImagem", {
        produtoId: produtoId,
        nome: imagem.imagemNome,
      })
      .then((codes) => {
        notification("warning", "Imagem removida");
        return listarImagens();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Imagem inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const table = {
    title: "Imagens",
    array: imagens,
    columns: [
      {
        name: "imagemNome",
        label: "Nome",
      },
      {
        name: "principal",
        label: "Principal",
        checkbox: true,
        onCheck: selecionarImagemPrincipal,
      },
    ],
    actions: [
      {
        name: "visualizar",
        icon: "zmdi zmdi-download",
        action: visualizarImagem,
      },
      {
        name: "remove",
        icon: "zmdi zmdi-delete",
        action: removerImagem,
      },
    ],
  };

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fProduto} />}
      {produtoId > 0 && (
        <>
          <Form formData={formUpload} />
          <ActionTable structure={table} />
          <Estoque produtoId={produtoId} />
          <br />
          <EscolasExclusividade produtoId={produtoId} />
        </>
      )}
    </div>
  );
}
